import { render, staticRenderFns } from "./room-selector.vue?vue&type=template&id=ba9da83c&scoped=true"
import script from "./room-selector.vue?vue&type=script&lang=js"
export * from "./room-selector.vue?vue&type=script&lang=js"
import style0 from "./room-selector.vue?vue&type=style&index=0&id=ba9da83c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9da83c",
  null
  
)

export default component.exports